export interface MaintenanceDefectDayCount {
  day: string;
  not_fixed: number;
  in_progress: number;
  open: number;
  fixed: number;
}

export interface MaintenanceDefectChartDay extends MaintenanceDefectDayCount {
  label: string;
  count: number;
  periodHighlighted: boolean;
}

export function buildMaintenanceDefectChartDays(
  rows: readonly MaintenanceDefectDayCount[],
  options: {
    now: Date;
    selectedStartKey: string;
    selectedEndKey: string;
    highlightSelectedDay: boolean;
  },
): MaintenanceDefectChartDay[] {
  const byDay = new Map(rows.map((row) => [row.day, row]));
  const today = new Date(`${options.now.toISOString().slice(0, 10)}T00:00:00.000Z`);
  const start = new Date(today);
  start.setUTCDate(start.getUTCDate() - 6);

  const days: MaintenanceDefectChartDay[] = [];
  for (const cursor = start; cursor <= today; cursor.setUTCDate(cursor.getUTCDate() + 1)) {
    const day = cursor.toISOString().slice(0, 10);
    const row = byDay.get(day);
    const open = row?.open ?? 0;
    const fixed = row?.fixed ?? 0;
    days.push({
      day,
      label: cursor.toLocaleDateString('en-GB', { weekday: 'short', timeZone: 'UTC' }).slice(0, 3),
      not_fixed: row?.not_fixed ?? open,
      in_progress: row?.in_progress ?? 0,
      open,
      fixed,
      count: open + fixed,
      periodHighlighted: options.highlightSelectedDay
        && day >= options.selectedStartKey
        && day <= options.selectedEndKey,
    });
  }

  return days;
}
